import React, { Component } from 'react';
import ActivitiesCard from './ActivitiesCard';
import ScrollRight from '../../scroll/ScrollRight';
import ScrollLeft from '../../scroll/ScrollLeft';
import activities from '../../../data/activities';
import windowSize from 'react-window-size';
import { api_url, headers } from '../../../common/config';

class ActivitesCardsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            click: 0,
            scroll: 0,
            start: 0,
            end: 5,
            width: this.props.windowWidth,
            courses: null,
        };
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    };

    clickEnd = () => {
        if (this.state.width > 1350) {
            return 3;
        } else if (this.state.width <= 1350 && this.state.width > 900) {
            return 4;
        } else if (this.state.width <= 990 && this.state.width > 480) {
            return 5;
        } else if (this.state.width <= 480) {
            return 5;
        }
    };

    componentDidMount() {
        fetch(`${api_url}/autism/items/courses?filter[status]=published`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    courses: res.data,
                    clickEnd: res.data.length,
                });
            });

        window.addEventListener('resize', this.updateDimensions);
        this.setEnd();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        this.setEnd();
    }

    end = () => {
        if (this.state.width > 1350) {
            return 5;
        } else if (this.state.width <= 1350 && this.state.width > 600) {
            return 4;
        } else if (this.state.width <= 600 && this.state.width > 480) {
            return 2;
        } else if (this.state.width <= 480) {
            return 2;
        }
    };

    setEnd = () => {
        this.setState({
            end: this.end(),
        });
    };

    scroll = () => {
        if (this.state.width > 990) {
            return 300;
        } else if (this.state.width <= 990 && this.state.width > 600) {
            return 230;
        } else if (this.state.width <= 600 && this.state.width > 500) {
            return 180;
        } else if (this.state.width <= 500 && this.state.width > 200) {
            return 215;
        }
    };

    handleLeftClick = () => {
        this.setState({
            click: this.state.click + 1,
            scroll: this.state.scroll + this.scroll(),
            start: this.state.start + 1,
            end: this.state.end + 1,
        });
    };

    handleRightClick = () => {
        this.setState({
            click: this.state.click - 1,
            scroll: this.state.scroll - this.scroll(),
            start: this.state.start - 1,
            end: this.state.end - 1,
        });
    };

    render() {
        const courses = this.props.courses;
        const files = this.props.files;
        let classname = `disable-${this.state.start} disable-${this.state.end}`;
        let cards = courses.map((card) => (
            <div
                key={card.id}
                className={`${classname} act-crd ${
                    courses.length < 4 ? 'mx-3' : ''
                }`}
            >
                <ActivitiesCard
                    ar_type={card.ar_tags}
                    en_type={card.en_tags}
                    ar_title={card.ar_title}
                    en_title={card.en_title}
                    ar_name={card.ar_author_name}
                    en_name={card.en_author_name}
                    ar_job={card.ar_author_title}
                    en_job={card.en_author_title}
                    ar_desc={card.description}
                    en_desc={card.en_description}
                    ar_date={card.ar_date}
                    en_date={card.en_date}
                    ar_time={card.ar_time}
                    en_time={card.en_time}
                    image={card.image}
                    url={card.form_url}
                    files={files}
                />
            </div>
        ));
        let displayedCards = cards.splice(0, this.state.end);

        return (
            <div className='activity-container'>
                <div className='arrows-container'>
                    <div className='arrow-right'>
                        <div
                            className={`${
                                this.state.click === 0 ? 'invisible' : ''
                            }`}
                            onClick={this.handleRightClick}
                        >
                            <ScrollRight />
                        </div>
                    </div>
                    <div className='arrow-left' onClick={this.handleLeftClick}>
                        <div
                            className={`${
                                this.state.click === this.state.clickEnd - 1 ||
                                this.props.courses.length < this.end()
                                    ? 'invisible'
                                    : ''
                            }`}
                        >
                            <ScrollLeft />
                        </div>
                    </div>
                </div>
                <div
                    className={`${
                        courses.length < 4
                            ? 'activities-small'
                            : 'activities-cards'
                    }`}
                    style={{
                        transform: `translateX(${this.state.scroll}px)`,
                        transition: 'transform 1s',
                    }}
                >
                    {displayedCards}
                </div>
            </div>
        );
    }
}

export default windowSize(ActivitesCardsList);
